import { render, staticRenderFns } from "./weishequ.vue?vue&type=template&id=b28ab072&scoped=true&"
import script from "./weishequ.vue?vue&type=script&lang=js&"
export * from "./weishequ.vue?vue&type=script&lang=js&"
import style0 from "./weishequ.vue?vue&type=style&index=0&id=b28ab072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28ab072",
  null
  
)

export default component.exports